(function(){
  document.addEventListener('DOMContentLoaded', function() {
   let tabsControls = document.querySelectorAll('.filter_strip--item');
    tabsControls.forEach( elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        let dataTab = elem.getAttribute('data-tab');
        let tabContent = document.querySelector(`.content_tab[data-tab="${dataTab}"]`);
        document.querySelectorAll('[data-tab]').forEach( elem => {
          elem.classList.remove('active');
        });
        elem.classList.add('active');
        tabContent.classList.add('active');
      });
    });
 }, false);
})();
